module.exports = __webpack_public_path__ + "img/fiscal_information_border.3984b674.svg";